import { Col, Input, Label, Row } from "reactstrap";
import Select from "../../Common/AppSelect";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { Card } from "reactstrap";
import { companiesHouseGovUKSearchCompanies } from "../../../store/companiesHouseGovUK/action";
import ClickOutside from "../../Common/ClickOutsideComponent";
import { useDispatch, useSelector } from "react-redux";
export function TabStepABusinessNameAndAddress({
  customerDetails,
  setCustomerDetails,
  paymentTermsList,
  PaymentMethodListAPI,
  toggleVerticalTab,
  activeVerticalTab,
  handleCheckEachStep,
}) {
  const [searchQuery, setSearchQuery] = useState("");
  const [showResults, setShowResults] = useState(false);
  const [selectCompanyFromSearch, setSelectCompanyFromSearch] = useState(null);
  const dispatch = useDispatch();
  const { companies: chCompanies, loading: chLoading } = useSelector(
    (state) => ({
      companies: state.CompaniesHouseGovUK.companies,
      loading: state.CompaniesHouseGovUK.loading,
    })
  );

  useEffect(() => {
    if (customerDetails?.CustomerBusinessType_Id !== "1") return;
    const delay = setTimeout(() => {
      if (searchQuery.trim().length > 0) {
        dispatch(companiesHouseGovUKSearchCompanies({ id: searchQuery }));
      }
    }, 500);
    return () => clearTimeout(delay);
  }, [searchQuery, customerDetails?.CustomerBusinessType_Id]);

  // // when switching to Business
  // clearCHState();
  // setCustomerDetails({ ...customerDetails, CustomerBusinessType_Id: "1" });
  //
  // // when switching to Person
  // clearCHState();
  // setCustomerDetails({ ...customerDetails, CustomerBusinessType_Id: "2" });
  const clearCHState = () => {
    setSearchQuery("");
    setShowResults(false);
    setSelectCompanyFromSearch(null);
  };
  return (
    <div id={"zdiv_customer_create_step_a_01"}>
      <div>
        <h5>Business Name & Address</h5>
      </div>

      <Row className="g-3">
        <Col lg={12}>
          <div>
            <div className={"pt-4"}>
              <div htmlFor="company_name-field" className="form-label">
                Please select the type of business
              </div>
              <div>
                <input
                  type="radio"
                  className="btn-check"
                  name="transaction_type"
                  id="option2"
                  value={"1"}
                  checked={customerDetails.CustomerBusinessType_Id === "1"}
                  autoComplete="off"
                  onChange={() => {
                    setCustomerDetails({
                      ...customerDetails,
                      CustomerBusinessType_Id: "1",
                    });
                  }}
                />
                <label
                  className={
                    customerDetails.CustomerBusinessType_Id === "1"
                      ? "btn btn-primary"
                      : "btn btn-soft-primary"
                  }
                  htmlFor="option2"
                >
                  Business
                </label>{" "}
                <input
                  type="radio"
                  className="btn-check "
                  name="transaction_type"
                  id="option1"
                  autoComplete="off"
                  checked={customerDetails?.CustomerBusinessType_Id === "2"}
                  value={"2"}
                  onChange={() => {
                    setCustomerDetails({
                      ...customerDetails,
                      CustomerBusinessType_Id: "2",
                    });
                  }}
                />
                <label
                  className={
                    customerDetails.CustomerBusinessType_Id === "2"
                      ? "btn btn-primary"
                      : "btn btn-soft-primary"
                  }
                  htmlFor="option1"
                >
                  Person
                </label>
              </div>
            </div>
          </div>
        </Col>
        {customerDetails?.CustomerBusinessType_Id && (
          <>
            {customerDetails?.CustomerBusinessType_Id === "1" && (
              <Col lg={12}>
                <ClickOutside onClick={() => setShowResults(false)}>
                  <Label>
                    Search Business Name{" "}
                    <span className="text-muted">
                      <i className="fa-solid fa-magnifying-glass"></i>
                    </span>
                  </Label>

                  <Input
                    type="search"
                    className="form-control"
                    placeholder="Type to search Companies House…"
                    value={customerDetails?.BusinessName}
                    onFocus={() => setShowResults(true)}
                    onBlur={() => setTimeout(() => setShowResults(false), 300)}
                    onChange={(e) => {
                      const v = e.target.value;
                      setCustomerDetails({
                        ...customerDetails,
                        BusinessName: v,
                      });
                      if (!v) {
                        clearCHState();
                      } else {
                        setSearchQuery(v);
                        setShowResults(true);
                      }
                    }}
                  />

                  {searchQuery.length > 0 && showResults && (
                    <div className="mt-1 small text-muted">
                      Companies House search results
                    </div>
                  )}

                  {showResults && (
                    <div
                      className="pb-2 company-house-response-list mt-1"
                      style={{
                        maxHeight: 280,
                        overflowY: "auto",
                        border: "1px solid #eee",
                        borderRadius: 6,
                      }}
                    >
                      {chLoading && (
                        <div className="p-2 small text-muted">Searching…</div>
                      )}
                      {chCompanies?.items?.map((item, index) => (
                        <Card
                          key={index}
                          className="d-flex flex-row justify-content-between align-items-center p-2 m-1"
                        >
                          <div className="d-flex flex-column flex-wrap">
                            <div className="fw-semibold">{item.title}</div>
                            {item.description && (
                              <div className="text-muted small">
                                {item.description}
                              </div>
                            )}
                            <div className="small">
                              {item?.address?.address_line_1 ?? ""}{" "}
                              {item?.address?.address_line_2 ?? ""}{" "}
                              {item?.address?.locality ?? ""}{" "}
                              {item?.address?.postal_code ?? ""}
                            </div>
                          </div>
                          <div>
                            <button
                              type="button"
                              className="btn btn-sm btn-primary"
                              onClick={() => {
                                setCustomerDetails({
                                  ...customerDetails,
                                  BusinessName: item?.title ?? "",
                                  RegNo:
                                    item?.company_number ??
                                    customerDetails?.RegNo ??
                                    "",
                                  AddressLine1: `${
                                    item?.address?.premises ?? ""
                                  } ${
                                    item?.address?.address_line_1 ?? ""
                                  }`.trim(),
                                  AddressLine2:
                                    item?.address?.address_line_2 ?? "",
                                  AddressCity: item?.address?.locality ?? "",
                                  AddressCounty:
                                    item?.address?.region ??
                                    customerDetails?.AddressCounty ??
                                    "",
                                  AddressPostCode:
                                    item?.address?.postal_code ?? "",
                                  AddressCountry: item?.address?.country ?? "",
                                });
                                setSearchQuery("");
                                setShowResults(false);
                                setSelectCompanyFromSearch(item);
                              }}
                            >
                              Select
                            </button>
                          </div>
                        </Card>
                      ))}
                    </div>
                  )}

                  {/* Manual override fields */}
                  <div className="mt-2">
                    <Label>
                      Business Name <span className="text-danger">*</span>
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      value={customerDetails?.BusinessName}
                      onChange={(e) =>
                        setCustomerDetails({
                          ...customerDetails,
                          BusinessName: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="mt-2">
                    <Label>Registration Number</Label>
                    <Input
                      type="text"
                      className="form-control"
                      value={customerDetails?.RegNo || ""}
                      onChange={(e) =>
                        setCustomerDetails({
                          ...customerDetails,
                          RegNo: e.target.value,
                        })
                      }
                    />
                  </div>
                </ClickOutside>
              </Col>
            )}
            {customerDetails.CustomerBusinessType_Id === "2" && (
              <>
                <Col lg={4}>
                  <div>
                    <Input
                      name="PersonTitle"
                      id="PersonTitle"
                      className="form-control"
                      placeholder={"Your Title"}
                      type="text"
                      onChange={(e) => {
                        setCustomerDetails({
                          ...customerDetails,
                          PersonTitle: e.target.value,
                        });
                      }}
                      value={customerDetails?.PersonTitle}
                    />
                  </div>
                </Col>

                <Col lg={4}>
                  <div>
                    <Input
                      name="PersonFirstName"
                      id="PersonFirstName"
                      className="form-control"
                      placeholder={"First Name"}
                      type="text"
                      onChange={(e) => {
                        setCustomerDetails({
                          ...customerDetails,
                          PersonFirstName: e.target.value,
                        });
                      }}
                      value={customerDetails?.PersonFirstName}
                    />
                  </div>
                </Col>
                <Col lg={4}>
                  <div>
                    <Input
                      name="PersonLastName"
                      id="PersonLastName"
                      className="form-control"
                      placeholder={"Last Name"}
                      type="text"
                      onChange={(e) => {
                        setCustomerDetails({
                          ...customerDetails,
                          PersonLastName: e.target.value,
                        });
                      }}
                      value={customerDetails?.PersonLastName}
                    />
                  </div>
                </Col>
              </>
            )}
            <Col lg={6}>
              <div>
                <Input
                  name="AddressLine1"
                  id="AddressLine1"
                  className="form-control"
                  placeholder={"Enter First Line of Address"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressLine1: e.target.value,
                    });
                  }}
                  value={customerDetails?.AddressLine1}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <Input
                  name="AddressLine2"
                  id="AddressLine2"
                  className="form-control"
                  placeholder={"Enter Second Line of Address"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressLine2: e.target.value,
                    });
                  }}
                  value={customerDetails?.AddressLine2}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <Input
                  name="AddressLine3"
                  id="AddressLine3"
                  className="form-control"
                  placeholder={"Enter Third Line of Address"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressLine3: e.target.value,
                    });
                  }}
                  value={customerDetails?.AddressLine3}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <Input
                  name="AddressLine4"
                  id="AddressLine4"
                  className="form-control"
                  placeholder={"Enter Fourth Line of Address"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressLine4: e.target.value,
                    });
                  }}
                  value={customerDetails.AddressLine4}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <Input
                  name="AddressCity"
                  id="AddressCity"
                  className="form-control"
                  placeholder={"Enter City"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressCity: e.target.value,
                    });
                  }}
                  value={customerDetails.AddressCity}
                />
              </div>
            </Col>

            <Col lg={6}>
              <div>
                <Input
                  name="AddressCounty"
                  id="AddressCounty"
                  className="form-control"
                  placeholder={"Enter County"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressCounty: e.target.value,
                    });
                  }}
                  value={customerDetails.AddressCounty}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <Input
                  name="AddressPostCode"
                  id="AddressPostCode"
                  className="form-control"
                  placeholder={"Enter PostCode"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressPostCode: e.target.value,
                    });
                  }}
                  value={customerDetails.AddressPostCode}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <Input
                  name="AddressCountry"
                  id="AddressCountry"
                  className="form-control"
                  placeholder={"Enter Country"}
                  type="text"
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      AddressCountry: e.target.value,
                    });
                  }}
                  value={customerDetails.AddressCountry}
                />
              </div>
            </Col>

            <Col lg={12}>
              <div>
                <Label>
                  Payment Term <span className={"text-danger"}>*</span>
                </Label>
                <Select
                  isClearable={true}
                  className="mb-0 job-select2"
                  placeholder={"Select Payment Term"}
                  value={
                    customerDetails.PaymentTerm_Id
                      ? {
                          label: paymentTermsList?.find(
                            (item) =>
                              item?.Id === customerDetails?.PaymentTerm_Id
                          )?.Name,
                          value: customerDetails?.PaymentTerm_Id,
                          id: customerDetails?.PaymentTerm_Id,
                        }
                      : []
                  }
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      PaymentTerm_Id: e?.value,
                    });
                  }}
                  options={
                    !isEmpty(paymentTermsList)
                      ? paymentTermsList?.map((item) => ({
                          label: item?.Name,
                          value: item?.Id,
                          id: item?.Id,
                        }))
                      : []
                  }
                  id="country-select"
                ></Select>
              </div>
            </Col>
            <Col lg={12}>
              <div>
                <Label>Payment Method</Label>
                <Select
                  isClearable={true}
                  className="mb-0 job-select2"
                  placeholder={"Select Payment Method"}
                  value={
                    customerDetails.PaymentMethod_Id
                      ? {
                          label: PaymentMethodListAPI?.find(
                            (item) =>
                              item?.Id === customerDetails?.PaymentMethod_Id
                          )?.Name,
                          value: customerDetails?.PaymentMethod_Id,
                          id: customerDetails?.PaymentMethod_Id,
                        }
                      : []
                  }
                  onChange={(e) => {
                    setCustomerDetails({
                      ...customerDetails,
                      PaymentMethod_Id: e?.value,
                    });
                  }}
                  options={
                    !isEmpty(PaymentMethodListAPI)
                      ? PaymentMethodListAPI?.map((item) => ({
                          label: item?.Name,
                          value: item?.Id,
                          id: item?.Id,
                        }))
                      : []
                  }
                  id="country-select"
                ></Select>
              </div>
            </Col>
            <Col lg={12}>
              <div>
                {/* Proforma Invoice must be created before Invoice   FlagProformaInvoiceRequiredBeforeInvoice*/}
                <div className={"d-flex mb-2 align-items-center"}>
                  <input
                    type={"checkbox"}
                    className={"me-2"}
                    checked={
                      customerDetails.FlagProformaInvoiceRequiredBeforeInvoice ===
                      "1"
                    }
                    onChange={(e) => {
                      setCustomerDetails((prevState) => {
                        const newState = { ...prevState };
                        newState.FlagProformaInvoiceRequiredBeforeInvoice = e
                          .target.checked
                          ? "1"
                          : "0";
                        return newState;
                      });
                    }}
                  />
                  <label
                    htmlFor="ProformaInvoiceRequiredBeforeInvoice"
                    className={"m-0 p-0"}
                  >
                    Proforma Invoice must be created before Invoice
                  </label>
                </div>
              </div>
              <div className={"d-flex"}>
                <div className={"d-flex align-items-center py-2"}>
                  {/*    Checkbox Disable Invoicing FlagDisableInvoice */}
                  <input
                    type={"checkbox"}
                    className={"me-2"}
                    checked={customerDetails.FlagDisableInvoice === "1"}
                    onChange={(e) => {
                      setCustomerDetails((prevState) => {
                        const newState = { ...prevState };
                        newState.FlagDisableInvoice = e.target.checked
                          ? "1"
                          : "0";
                        return newState;
                      });
                    }}
                  />
                  <label htmlFor="DisableInvoice" className={"m-0 p-0"}>
                    Disable Invoicing
                  </label>
                </div>
                <div className={"d-flex align-items-center py-2"}>
                  {/*    Disable Proforma Invoicing FlagDisableProformaInvoice*/}
                  <input
                    type={"checkbox"}
                    className={"ms-3 me-2"}
                    checked={customerDetails.FlagDisableProformaInvoice === "1"}
                    onChange={(e) => {
                      setCustomerDetails((prevState) => {
                        const newState = { ...prevState };
                        newState.FlagDisableProformaInvoice = e.target.checked
                          ? "1"
                          : "0";
                        return newState;
                      });
                    }}
                  />
                  <label htmlFor="DisableProformaInvoice" className={"m-0 p-0"}>
                    Disable Proforma Invoicing
                  </label>
                </div>
              </div>
            </Col>
          </>
        )}
      </Row>

      <div className="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          className="btn btn-success btn-label right ms-auto nexttab nexttab"
          onClick={() => {
            handleCheckEachStep(activeVerticalTab + 1);
          }}
        >
          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
          Contact information
        </button>
      </div>
    </div>
  );
}
